import { ROUTES } from 'config/routes'

type BuildAttachmentPreviewUrlParams = {
  deliveryReportUid: string
  shipmentUid: string
  visitId: number
  attachmentId: number
  name: string
}

/**
 * 添付ファイル確認用ページ（別タブ）への URL を組み立てる純粋関数。
 * ファイル名は表示・拡張子判定用に query で渡す。
 */
export const buildAttachmentPreviewUrl = ({
  deliveryReportUid,
  shipmentUid,
  visitId,
  attachmentId,
  name,
}: BuildAttachmentPreviewUrlParams): string =>
  `${ROUTES.spDeliveryWorkAttachmentPreview
    .replace(':deliveryReportUid', deliveryReportUid)
    .replace(':shipmentUid', shipmentUid)
    .replace(':visitId', String(visitId))
    .replace(':attachmentId', String(attachmentId))}?name=${encodeURIComponent(name)}`
